class KurumIcmalSorguResponse {
    kurumId?: number = null;
    kurumAdi?: string = "";
    hastaSayi?: number = null;
    islemSayi?: number = null;
    tutar?: number = null;
    kdvliTutar?: number = null;
    kdvsizTutar?: number = null;
    sozlesmeTuru?: number = null;
    parabirimId?: number = null;
    usdTutar?: number = null;
    eurTutar?: number = null;
    dovizTutar?: number = null;
};
export default KurumIcmalSorguResponse;